// src/unAuth/components/Hero.js
import React from "react";
import "./Hero.css";

export default function Hero() {
  return (
    <header className="hero" id="hero" data-animate="fade-up">
      <h1 className="hero-title">
        Free AI YouTube Timestamp Generator
      </h1>
      <p className="hero-subtitle">
        Create shareable chapter timestamps for any YouTube video in seconds.
        Paste a link, get AI-generated timestamps, then copy and add them to
        your description so viewers can jump to the parts that matter.
      </p>
      <p className="hero-value">
        We give you formatted, clickable chapters; 10+ languages; one-click copy;
        and step-by-step guides—so you get a ready-to-use result, not raw data.
      </p>
    </header>
  );
}
